import {
  Component,
  OnInit,
  Input,
  ViewChild,
  NgZone,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { PropertyFinder } from '../../shared/services/property-finder.service';
import {} from '@types/googlemaps';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
} from '@angular/material/dialog';
import { PropertyFinderPopupComponent } from '../profile/profile-timeline/profile-timeline-form/mail/property-finder-popup/property-finder-popup.component';
import { AgentProfileService } from '../../shared/services/agent-profile.service';
import { AgmCoreModule, MapsAPILoader } from '@agm/core';
import { MatSnackBar } from '@angular/material';
import { Broadcaster } from '../../shared/services/broadcaster.service';
import { IfStmt } from '@angular/compiler';
import { isEmpty } from 'rxjs-compat/operator/isEmpty';
import { JwtDecoder } from '../../shared/services/auth/jwt-decoder.service';
import { LeadProfileData } from '../profile/profile-settings/profile-data.service';

const _ = require('lodash');

@Component({
  selector: 'app-property-finder',
  templateUrl: './property-finder.component.html',
  styleUrls: ['./property-finder.component.scss'],
  providers: [PropertyFinder],
})
export class PropertyFinderComponent implements OnInit {
  @ViewChild('addresstext') addresstext: any;
  @Input() updatedProp;
  @Input() view;
  @Input() leadLocation;
  @Input() recommenderData;
  @Input() propertyRecommenderData;

  public results;
  public latitude;
  public longitude;
  public listLoading;
  public place = '';
  public place2 = '';
  public autocomplete;
  public autocomp;
  public shownMaxBudget = '$5.00M';
  public shownMinBudget = '$0K';
  public allChecked = false;
  public airbnbChecked = false;
  public tradChecked = false;
  public chosenProperties = [];
  public propertiesRequest: any;
  public oldSearch;
  public fullResults = [];
  public firstProp: number = 0;
  public propCount: number;
  public disableNext: boolean = false;
  public disablePrev: boolean = false;
  public fclicked: boolean;
  public propertylink;
  public citiesOfInterest = [];
  public limitExceeded: boolean = false;
  public removedPropsFromPopup = [];

  public uiState = {
    loading: false,
    milesFilter: {
      value: 250,
    },
    budgetFilter: {
      config: {
        from: 0,
        to: 5000000,
        min: 0,
        max: 5000000,
        translate: function (value) {
          var price;
          if (value < 1000000) {
            value = value / 1000;
            value = parseInt(value, 10);
            price = 'K';
          } else {
            value = value / 1000000;
            value = parseFloat(value).toFixed(2);
            price = 'M';
          }
          return '$' + value + price;
        },
      },
    },
    rentalStrategyFilter: {
      strategies: ['All', 'Airbnb', 'Traditional'],
    },
    bedsFilter: {
      options: ['Any', 0, 1, 2, 3, 4, 5],
    },
    bathsFilter: {
      options: ['Any', 0, 1, 2, 3, 4, 5],
    },
    typesFilter: {
      types: [
        'Single Family Residential',
        'Multi Family',
        'Condo/Coop',
        'Other',
      ],
      tempValue: '',
    },
    savedHomesFecthed: false,
  };
  public search = {
    miles: 250,
    locations: [
      {
        state: 'IL',
        city: 'Chicago',
        center_lat: 41.8781136,
        center_lng: -87.62979819999998,
      },
    ],
    execlude_id_list: [], // to do
    min_budget: 0,
    max_budget: 5000000,
    rental_sort: 'All',
    max_beds: 5,
    min_beds: 0,
    max_baths: 5,
    min_baths: 0,
    property_type: [],
    serverPage: 1,
    items: 6,
  };
  agentProfileService: any;
  agentSubscription: any;
  agentPlan: any;
  checked1: boolean;
  checked2: boolean;
  checked3: boolean;
  checked4: boolean;
  recommenderDataIsSet: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<any>,
    private PropertyFinderService: PropertyFinder,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private agentInfoService: AgentProfileService,
    private mapsAPILoader: MapsAPILoader,
    private snack: MatSnackBar,
    private broadcaster: Broadcaster,
    private userInfo: JwtDecoder,
  ) {}

  ngOnInit() {
    if (this.recommenderData) {
      this.recommenderDataIsSet = true;
      this.setRecommenderValues();
    }
    var input = <HTMLInputElement>document.getElementById('input_bar');
    var options = {
      componentRestrictions: {
        country: 'us',
      },
      types: ['(cities)'],
      fields: ['address_components', 'geometry', 'formatted_address'],
    };
    this.autocomp = new google.maps.places.Autocomplete(input, options);
    google.maps.event.addListener(this.autocomp, 'place_changed', () => {
      //get the place result
      this.place2 = this.autocomp.getPlace();
      if (this.place2) {
        let parsedLocation = this.PropertyFinderService.parseLocationComponents(
          this.place2,
        );
        let city = {
          state: null,
          city: null,
          center_lat: null,
          center_lng: null,
        };
        city.state = parsedLocation.state.toUpperCase();
        city.city = parsedLocation.city.toLowerCase();
        city.center_lat = parsedLocation.lat;
        city.center_lng = parsedLocation.lng;

        this.search.locations.push(city);
        this.place2 = '';

        if (city) {
          this.firstProp = 0;
          this.fullResults = [];
          this.getProperties();
        }
      }
    });
    // this.getAgentCities();
    this.getProperties();
    this.getAgentPlan();
  }

  ngAfterViewChecked() {
    var filtersMenu = document.getElementsByClassName('filters-menu');
    this.fclicked = filtersMenu.length === 0 ? false : true;
    this.cdr.detectChanges();
  }

  removeLocation(value) {
    if (this.search.locations.length >= 2) {
      this.search.locations = this.search.locations.filter(item => {
        if (item === value) {
          return false;
        }
        return true;
      });
      this.getProperties(true);
    }
  }

  setMiles(event) {
    this.search.miles = event.from;
    this.getProperties(true);
  }

  setBudget(event) {
    this.search.min_budget = event.from;
    this.search.max_budget = event.to;
    this.shownMinBudget = this.uiState.budgetFilter.config.translate(
      this.search.min_budget,
    );
    this.shownMaxBudget = this.uiState.budgetFilter.config.translate(
      this.search.max_budget,
    );
    this.getProperties(true);
  }

  openFilters() {
    var input = <HTMLInputElement>document.getElementById('input_barr');
    var options = {
      componentRestrictions: {
        country: 'us',
      },
      types: ['(cities)'],
      fields: ['address_components', 'geometry', 'formatted_address'],
    };
    this.autocomplete = new google.maps.places.Autocomplete(input, options);
    google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
      //get the place result
      this.place = this.autocomplete.getPlace();
      if (this.place) {
        let parsedLocation = this.PropertyFinderService.parseLocationComponents(
          this.place,
        );
        let city = {
          state: null,
          city: null,
          center_lat: null,
          center_lng: null,
        };
        city.state = parsedLocation.state.toUpperCase();
        city.city = parsedLocation.city.toLowerCase();
        city.center_lat = parsedLocation.lat;
        city.center_lng = parsedLocation.lng;

        let index = this.search.locations.findIndex(function (obj) {
          return obj.city == city.city;
        });
        if (index === -1) {
          this.search.locations.push(city);
        }
        this.place = '';
        if (city) {
          this.firstProp = 0;
          this.fullResults = [];
          this.getProperties(true);
        }
      }
    });
  }

  getAgentPlan() {
    if (!this.agentInfoService.readyAgentSubscription) {
      this.agentInfoService.agentSubsciptionFetched.subscribe(data => {
        this.agentSubscription = data;
        this.agentPlan = this.agentSubscription.results[0].plan;
      });
    } else {
      this.agentSubscription = this.agentInfoService.readyAgentSubscription;
      this.agentPlan = this.agentSubscription.results[0].plan;
    }
  }

  pushPropertyFinderData = function (oldVal) {
    var locationsFormatted = oldVal.locations.map(a => a.city + ',' + a.state);
    locationsFormatted = locationsFormatted.join(';');
    var propertyTypes = oldVal.property_type.join(',');
    var obj = {
      locations: locationsFormatted,
      miles: oldVal.miles,
      minBudget: oldVal.min_budget,
      maxBudget: oldVal.max_budget,
      rentalSort: oldVal.rental_sort,
      propertyType: propertyTypes,
      minBedrooms: oldVal.min_beds,
      maxBedrooms: oldVal.max_beds,
      minBathrooms: oldVal.min_baths,
      maxBathrooms: oldVal.max_baths,
    };
    (<any>window)._mva.push({
      USER_ID:
        ((<any>window).mvGDPR && (<any>window).mvGDPR.isBlocked) ||
        this.userInfo.getUserInformation().user.id,
      PLAN: this.agentPlan,
      ACTION: 'SELECT_FILTERS',
      ENTITY: 'PROPERTY_FINDER_AGENTDASH',
      ACTION_DETAILS: {
        locations: locationsFormatted,
        miles: oldVal.miles,
        minBudget: oldVal.min_budget,
        maxBudget: oldVal.max_budget,
        rentalSort: oldVal.rental_sort,
        propertyType: propertyTypes,
        minBedrooms: oldVal.min_beds,
        maxBedrooms: oldVal.max_beds,
        minBathrooms: oldVal.min_baths,
        maxBathrooms: oldVal.max_baths,
      },
      URL: location.href,
    });
  };

  getProperties(view?) {
    if (view) {
      this.pushPropertyFinderData(this.search);
    }
    if (this.propertiesRequest) {
      this.propertiesRequest.unsubscribe();
    }
    this.listLoading = true;
    this.propertiesRequest = this.PropertyFinderService.getPropertiesList(
      this.search,
    ).subscribe(
      res => {
        if (res === undefined) {
          this.listLoading = false;
        } else if (res) {
          if (res.count == 0 && this.recommenderDataIsSet) {
            this.recommenderDataIsSet = false;
            this.propertyRecommenderData = false;
            this.search.min_budget = 0;
            this.search.max_budget = 5000000;
            this.search.max_beds = 5;
            this.search.min_beds = 0;
            this.search.max_baths = 5;
            this.search.min_baths = 0;
            this.recommenderData.property_type = [];
            this.uiState.budgetFilter.config.from = 0;
            this.uiState.budgetFilter.config.to = 5000000;
            this.shownMaxBudget = '$5.00M';
            this.shownMinBudget = '$0K';
            this.checked1 = false;
            this.checked2 = false;
            this.checked3 = false;
            this.checked4 = false;
            this.getProperties();
            return;
          }
          this.propCount = res.count;
          if (this.propCount < 7) {
            this.disableNext = true;
            this.disablePrev = true;
          }
          if (this.firstProp == 0) {
            this.disablePrev = true;
          } else {
            this.disablePrev = false;
          }
          var newArray = [];
          newArray = res.list;
          this.fullResults = [...this.fullResults, ...newArray];
          this.results = this.fullResults.slice(
            this.firstProp,
            this.firstProp + this.search.items,
          );
          this.results.map(v => (v.isClicked = false));
          this.broadcaster.savedChosenProperties.subscribe(data => {
            if (Object.keys(data).length > 0) {
              this.chosenProperties = Object.keys(data).map(key => {
                return data[key];
              });
              if (this.updatedProp.updatedProp.length > 0) {
                this.updatedProp.updatedProp.forEach(element => {
                  let i = this.chosenProperties.findIndex(function (obj) {
                    return obj.id == element;
                  });
                  if (i > -1) {
                    this.chosenProperties.splice(i, 1);
                  }
                });
                this.updatedProp.updatedProp = [];
              }
              this.chosenProperties.forEach(element => {
                let i = this.results.findIndex(function (obj) {
                  return obj.id == element.id;
                });
                if (i > -1) {
                  this.results[i].isClicked = element.isClicked;
                }
              });
            }
          });
          this.firstProp += 6;
          this.listLoading = false;
        }
      },
      err => {
        this.listLoading = false;
      },
    );
  }

  setRentalSort(val) {
    this.search.rental_sort = val;
    if (val === 'all') {
      this.airbnbChecked = false;
      this.tradChecked = false;
      this.allChecked = true;
    } else if (val === 'airbnb') {
      this.allChecked = false;
      this.tradChecked = false;
      this.airbnbChecked = true;
    } else if (val === 'traditional') {
      this.airbnbChecked = false;
      this.allChecked = false;
      this.tradChecked = true;
    }
    this.firstProp = 0;
    this.fullResults = [];
    this.getProperties(true);
  }

  nextPage() {
    this.disablePrev = false;
    if (
      this.fullResults.slice(this.firstProp, this.fullResults.length).length <
      this.propCount
    ) {
      if (
        this.fullResults.slice(this.firstProp, this.fullResults.length)
          .length >= 6
      ) {
        this.listLoading = true;
        setTimeout(() => {
          this.listLoading = false;
          this.results = this.fullResults.slice(
            this.firstProp,
            this.firstProp + this.search.items,
          );
          this.firstProp += 6;
        }, 3000);
      } else {
        this.search.serverPage++;
        this.getProperties();
      }
    } else {
      this.disableNext = true;
    }
  }

  prevPage() {
    if (this.firstProp - this.search.items == 6) {
      this.firstProp -= 6;
      this.disablePrev = true;
      this.results = this.fullResults.slice(
        this.firstProp - this.search.items,
        this.firstProp,
      );
    } else if (this.firstProp - this.search.items >= 0) {
      this.firstProp -= 6;
      this.results = this.fullResults.slice(
        this.firstProp - this.search.items,
        this.firstProp,
      );
    } else {
      this.disablePrev = true;
    }
  }

  redfinEst(data, item) {
    let index = this.results.findIndex(function (obj) {
      return obj.id == item.id;
    });
    if (index > -1) {
      this.results[index].redfinEstimate = data;
    }
  }

  isAdded(data) {
    let i = this.results.findIndex(function (obj) {
      return obj.id == data.val.id;
    });
    if (i > -1) {
      this.results[i].isClicked = data.boolean;
    }
    if (data.boolean) {
      data.val['propertyLink'] = this.PropertyFinderService.buildPropertylink(
        data.val,
      );
      this.chosenProperties.push(data.val);
      if (this.chosenProperties.length > 6) {
        this.limitExceeded = true;
        this.snack.open(
          'You exceeded the limit of added properties, you can add up to 6.',
          'OK',
          { duration: 4000 },
        );
      }
    } else {
      let index = this.chosenProperties.findIndex(function (obj) {
        return obj.id == data.val.id;
      });
      if (index > -1) {
        this.removedPropsFromPopup.push(this.chosenProperties[index].id);
        this.chosenProperties.splice(index, 1);
      }
      if (this.chosenProperties.length <= 6) {
        this.limitExceeded = false;
      }
    }
    this.broadcaster.saveChosenProperties(this.chosenProperties);
  }
  addProperties() {
    var obj = {
      chosenProperties: this.chosenProperties,
      removedPropsFromPopup: this.removedPropsFromPopup,
    };
    this.dialogRef.close(obj);
  }
  setPropertyType(val, boolean) {
    if (boolean) {
      this.search.property_type.push(val);
    } else {
      var index = this.search.property_type.indexOf(val);
      if (index > -1) {
        this.search.property_type.splice(index, 1);
      }
    }
    this.firstProp = 0;
    this.fullResults = [];
    this.getProperties(true);
  }

  increaseMin(val) {
    if (val === 'beds') {
      if (
        this.search.min_beds <= 4 &&
        this.search.min_beds < this.search.max_beds
      ) {
        this.search.min_beds++;
      }
    } else if (val === 'baths') {
      if (
        this.search.min_baths <= 4 &&
        this.search.min_baths < this.search.max_baths
      ) {
        this.search.min_baths++;
      }
    }
    this.firstProp = 0;
    this.fullResults = [];
    this.getProperties(true);
  }
  decreaseMin(val) {
    if (val === 'beds') {
      if (this.search.min_beds >= 1) {
        this.search.min_beds--;
      }
    } else if (val === 'baths') {
      if (this.search.min_baths >= 1) {
        this.search.min_baths--;
      }
    }
    this.firstProp = 0;
    this.fullResults = [];
    this.getProperties(true);
  }
  increaseMax(val) {
    if (val === 'beds') {
      if (this.search.max_beds <= 4) {
        this.search.max_beds++;
      }
    } else if (val === 'baths') {
      if (this.search.max_baths <= 4) {
        this.search.max_baths++;
      }
    }
    this.firstProp = 0;
    this.fullResults = [];
    this.getProperties(true);
  }
  decreaseMax(val) {
    if (val === 'beds') {
      if (
        this.search.max_beds >= 1 &&
        this.search.max_beds > this.search.min_beds
      ) {
        this.search.max_beds--;
      }
    } else if (val === 'baths') {
      if (
        this.search.max_baths >= 1 &&
        this.search.max_baths > this.search.min_baths
      ) {
        this.search.max_baths--;
      }
    }
    this.firstProp = 0;
    this.fullResults = [];
    this.getProperties(true);
  }
  getAgentCities() {
    this.agentInfoService.getAgent().subscribe(data => {
      let addressField = null;
      const metaObject = data.user_profile.user_profile_meta;
      metaObject.forEach(meta => {
        if (meta.hasOwnProperty('cities_interested_in')) {
          addressField = meta['cities_interested_in'];
          this.citiesOfInterest = addressField.map(location => {
            const locationObj = location.split(',');
            const parsedCity = locationObj[0];
            const parsedState = locationObj[1];
            location = {
              city: parsedCity,
              state: parsedState,
            };
            return location;
          });

          //Make sure there are only 5 locations in this object before sending it to the filter
          this.citiesOfInterest = this.citiesOfInterest.slice(
            Math.max(this.citiesOfInterest.length - 5, 0),
          );
        }
        if (this.citiesOfInterest) {
          this.PropertyFinderService.getBounds(
            this.citiesOfInterest,
            this.mapsAPILoader,
          ).then(data => {
            this.citiesOfInterest = data;
            // Get the default search locations from the agents profile meta API
            if (this.citiesOfInterest && this.citiesOfInterest.length > 0) {
              // Parse the locations in the UI's readable format
              this.citiesOfInterest = this.citiesOfInterest.map(location => {
                let parsedLocation = {
                  state: location.state ? location.state.toUpperCase() : 'IL',
                  city: location.city ? location.city.toLowerCase() : 'chicago',
                  center_lat: location.lat ? location.lat : 41.8781136,
                  center_lng: location.lng ? location.lng : -87.62979819999998,
                };

                return parsedLocation;
              });

              this.search.locations = [];
              // Add the locations to the UI's search filter
              this.citiesOfInterest.forEach(element => {
                this.search.locations.push(element);
                this.place = '';
              });
              this.getProperties(true);
            }
          });
        }
      });
    });
  }

  setRecommenderValues() {
    this.search.min_budget = this.recommenderData.min_budget
      ? this.recommenderData.min_budget
      : 0;
    this.search.max_budget = this.recommenderData.max_budget
      ? this.recommenderData.max_budget
      : 5000000;
    this.search.max_beds = this.recommenderData.max_beds
      ? this.recommenderData.max_beds
      : 5;
    this.search.min_beds = this.recommenderData.min_beds
      ? this.recommenderData.min_beds
      : 0;
    this.search.max_baths = this.recommenderData.max_baths
      ? this.recommenderData.max_baths
      : 5;
    this.search.min_baths = this.recommenderData.min_baths
      ? this.recommenderData.min_baths
      : 0;
    this.recommenderData.property_type
      ? this.setPropertyType(this.recommenderData.property_type, true)
      : [];
    this.uiState.budgetFilter.config.from = this.recommenderData.min_budget
      ? this.recommenderData.min_budget
      : 0;
    this.uiState.budgetFilter.config.to = this.recommenderData.max_budget
      ? this.recommenderData.max_budget
      : 5000000;
    this.shownMaxBudget = this.recommenderData.max_budget
      ? this.formatPrice(this.recommenderData.max_budget)
      : '$5.00M';
    this.shownMinBudget =
      this.recommenderData.min_budget != null
        ? this.formatPrice(this.recommenderData.min_budget)
        : '$0K';

    if (this.recommenderData.property_type == 'Single Family Residential') {
      this.checked1 = true;
    } else if (this.recommenderData.property_type == 'Multi Family') {
      this.checked2 = true;
    } else if (
      this.recommenderData.property_type == 'Condo/Coop' ||
      this.recommenderData.property_type == 'Apartments'
    ) {
      this.checked3 = true;
    } else if (this.recommenderData.property_type == 'Other') {
      this.checked4 = true;
    }
  }

  formatPrice(value) {
    var price;
    if (value < 1000000) {
      value = value / 1000;
      value = parseInt(value, 10);
      price = 'K';
    } else {
      value = value / 1000000;
      value = parseFloat(value).toFixed(2);
      price = 'M';
    }
    return '$' + value + price;
  }
}
